"use client";
import { useState, useRef, useEffect, Fragment } from "react";
import {
  HiArrowLeftCircle,
  HiArrowRightCircle,
  HiChevronLeft,
  HiChevronRight,
} from "@onemind-services-llc/react-icons-ng/hi";
import { Box, HStack, Circle, IconButton } from "@chakra-ui/react";
import HeroCard, { HeroCardProps } from "../heroCard";

export type HeroProps = {
  list: Omit<HeroCardProps, "backgroundImage">[];
};

const HeroComp = ({ list }: HeroProps) => {
  const { currentIndex, handleNext, handlePrev } = useHandleNavigation(list.length);
  const currentItem = list[currentIndex];
  const newBackgroundImage = `/background/banner-bg${(currentIndex + 1) % 6}.png`;
  return (
    <Box position={"relative"}>
      <HeroCard {...currentItem} backgroundImage={newBackgroundImage} />
      {list.length > 1 && (
        <Fragment>
          <Box
            position="absolute"
            bottom={{ base: "65px", md: "15px" }}
            width="100%"
            display="flex"
            justifyContent="center"
          >
            <HStack justifyContent="center" mt={4} spacing={4}>
              {list.map((_, index) => (
                <Circle
                  key={index}
                  size="10px"
                  bg={index === currentIndex ? "white" : "#ababab"}
                />
              ))}
            </HStack>
          </Box>
          <HStack
            display={{ base: "flex", md: "none" }}
            justifyContent="center"
            alignContent={"center"}
            alignSelf={"center"}
            mt={2}
            spacing={4}
          >
            <IconButton
              aria-label="previous"
              color="primary.200"
              fontSize="30px"
              icon={<HiChevronLeft />}
              onClick={handlePrev}
              variant={"ghost"}
              _hover={{ cursor: "pointer", transform: "scale(1.1)" }}
            />
            <IconButton
              aria-label="previous"
              color="primary.200"
              fontSize="30px"
              icon={<HiChevronRight />}
              onClick={handlePrev}
              variant={"ghost"}
              _hover={{ cursor: "pointer", transform: "scale(1.1)" }}
            />
          </HStack>
          <Box display={{ base: "none", md: "block" }}>
            <IconButton
              aria-label="previous"
              color="white"
              fontSize="45px"
              icon={<HiArrowLeftCircle />}
              onClick={handlePrev}
              variant={"ghost"}
              _hover={{
                cursor: "pointer",
                transform: "translateY(-50%) scale(1.1)",
              }}
              position="absolute"
              left="10px"
              top="50%"
              transform="translateY(-50%)"
            />
            <IconButton
              aria-label="next"
              color="white"
              fontSize="45px"
              icon={<HiArrowRightCircle />}
              onClick={handleNext}
              variant={"ghost"}
              _hover={{
                cursor: "pointer",
                transform: "translateY(-50%) scale(1.1)",
              }}
              position="absolute"
              right="10px"
              top="50%"
              transform="translateY(-50%)"
            />
          </Box>
        </Fragment>
      )}
    </Box>
  );
};

export default HeroComp;

const useHandleNavigation = (numberOfSlides: number) => {
  const intervalRef = useRef<NodeJS.Timeout>(undefined);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevSlide) => (prevSlide - 1 + numberOfSlides) % numberOfSlides);
  };

  const handleNext = () => {
    setCurrentIndex((prevSlide) => (prevSlide + 1) % numberOfSlides);
  };

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      handleNext();
    }, 10000);

    return () => {
      clearInterval(intervalRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    currentIndex,
    handleNext,
    handlePrev,
  };
};
